/* tslint:disable */
/* eslint-disable */
/**
 * TRWL API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SearchV2Request
 */
export interface SearchV2Request {
    /**
     * 
     * @type {string}
     * @memberof SearchV2Request
     */
    'keyword': string;
    /**
     * 
     * @type {number}
     * @memberof SearchV2Request
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof SearchV2Request
     */
    'pageSize': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchV2Request
     */
    'fitIds'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SearchV2Request
     */
    'sortType'?: SearchV2RequestSortTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchV2Request
     */
    'sortMode'?: SearchV2RequestSortModeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchV2Request
     */
    'priceRange'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchV2Request
     */
    'brandIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchV2Request
     */
    'categoryIds'?: Array<number>;
}

export const SearchV2RequestSortTypeEnum = {
    Featured: 'FEATURED',
    BestSelling: 'BEST_SELLING',
    Release: 'RELEASE',
    Price: 'PRICE'
} as const;

export type SearchV2RequestSortTypeEnum = typeof SearchV2RequestSortTypeEnum[keyof typeof SearchV2RequestSortTypeEnum];
export const SearchV2RequestSortModeEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;

export type SearchV2RequestSortModeEnum = typeof SearchV2RequestSortModeEnum[keyof typeof SearchV2RequestSortModeEnum];


